import React from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'
import Price from 'lib/tags/price'

import TimeZone from '~/scenes/course/show/booking/time-zone'
import Availability from './availability'

import courseLogic from '~/scenes/course/show/logic'

export default function Content () {
  const {
    course: { bookingUrl, locationRates, currency }
  } = useValues(courseLogic)

  return (
    <div className='booking-component'>
      <TimeZone />
      <Availability />

      <div className='prices-locations'>
        {locationRates.in_studio ? (
          <div>
            <span className='starting-price'>
              {I18n.t('courses.show.from')} <Price price={locationRates.in_studio} currency={currency} />
            </span>
            <span className='green-box'>{I18n.t('courses.show.in_studio')}</span>
          </div>
        ) : null}
        {locationRates.webcam ? (
          <div>
            <span className='starting-price'>
              {I18n.t('courses.show.from')} <Price price={locationRates.webcam} currency={currency} />
            </span>
            <span className='green-box'>{I18n.t('courses.show.webcam')}</span>
          </div>
        ) : null}
        {locationRates.in_house ? (
          <div>
            <span className='starting-price'>
              {I18n.t('courses.show.from')} <Price price={locationRates.in_house} currency={currency} />
            </span>
            <span className='yellow-box'>{I18n.t('courses.show.in_house')}</span>
          </div>
        ) : null}
      </div>

      <div className='mt-20'>
        <a href={bookingUrl} className='button booklink dark-blue class-button' rel='nofollow'>
          {I18n.t('courses.show.request_booking')}
        </a>
      </div>
    </div>
  )
}
